import { Field, Label, Input as InputUI, Textarea } from '@headlessui/react';
import clsx from 'clsx';

type InputProps = {
  label?: string;
  placeholder?: string;
  isRequired?: boolean;
  error?: string;
} & React.InputHTMLAttributes<HTMLInputElement>;

export const Input = ({ ...props }: InputProps) => {
  const { error } = props;
  const hasError = Boolean(error);
  return (
    <div className="flex flex-col w-full">
      <Field>
        <div className="flex items-center gap-1">
          <Label className="text-sm/6 font-medium text-black">{props.label}</Label>
          {props.isRequired && <span className="text-red-500">*</span>}
        </div>
        <InputUI
          {...props}
          className={clsx(
            'block w-full rounded-lg border bg-white py-1.5 px-3 text-sm/6 text-black',
            'focus:outline-none data-[focus]:outline-2 data-[focus]:-outline-offset-2 data-[focus]:outline-white/25',
            props.className,
            hasError && 'border-red-500'
          )}
        />
        {hasError && <p className="text-red-500 text-xs mt-1">{error}</p>}
      </Field>
    </div>
  );
};

export type TextAreaProps = {
  label: string;
  placeholder?: string;
} & React.TextareaHTMLAttributes<HTMLTextAreaElement>;

export const TextArea = ({ ...props }: TextAreaProps) => {
  return (
    <div className="flex flex-col">
      <Field>
        <Label className="text-sm/6 font-medium text-black">{props.label}</Label>
        <Textarea
          {...props}
          className={clsx(
            'block w-full rounded-lg border bg-white py-1.5 px-3 text-sm/6 text-black',
            'focus:outline-none data-[focus]:outline-2 data-[focus]:-outline-offset-2 data-[focus]:outline-white/25'
          )}
        />
      </Field>
    </div>
  );
};
